import React from 'react';

import './css/footer-new.less';
import './new-header-style.less';

export default function NewFooterStyle() {
    return null;
}
